import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/order-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/OrderForm';
import { IOrder } from 'src/types/order';
import OrderEnum from 'src/enumerables/order-enum';
import { Paginated } from 'src/services/api-handlers/pagination';

import { QueryParams } from 'src/types/grid';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { IServiceType } from 'src/types/service-types';
import { toFormValues } from '../../helpers';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';
import Router from '../../../../../../navigation/router';

export interface StateProps {
    order: IOrder | null;
    inProgress: boolean;
    files: any;
    students: SelectObject[];
    serviceTypesOrder: Paginated<IServiceType>;
    orderTypeValue: string | number;
    statusItemValue: string | number;
    orderTypes: SelectObject[];
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getStudentsAct: (params: QueryParams) => void;
    getOrderServiceTypes: (params: QueryParams) => void;
    getFiles: (id: string | number) => void;
    addFiles: (id: string | number, files: any) => void;
    addFilesOrder: (id: string | number, files: any) => void;
    removeFile: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const OrderEditScreen: FC<Props> = (props: Props) => {
    const {
        order,
        match: {
            params: { id },
        },
        getFiles,
        files,
        addFilesOrder,
        addFiles,
        inProgress,
        removeFile,
        getData,
        getStudentsAct,
    } = props;

    useEffect(() => {
        if (!order || order.id !== id) {
            getData(id);
            getFiles(id);
            getStudentsAct({
                page: 1,
                itemsPerPage: 9000,
            });

            props.getOrderServiceTypes({
                page: 1,
                itemsPerPage: 9000,
            });
        }

        // eslint-disable-next-line
    }, [getFiles, getData, id]);

    const handeAdd = (files: any) => {
        addFiles(id, files);
    };
    const handeAddOrder = (files: any) => {
        addFilesOrder(id, files);
    };
    const handeRemove = (fileId: string | number) => {
        removeFile(fileId);
    };

    const typeEnumSubT = OrderEnum ? OrderEnum.getEnum('OrderSubtype') : {};
    const valuesOrderSubtype: SelectObject[] = getValFromEnum(typeEnumSubT);

    const AuthorizationSources = OrderEnum ? OrderEnum.getEnum('AuthorizationSource') : {};
    const valuesAuthorizationSources: SelectObject[] = getValFromEnum(AuthorizationSources);

    const AllocatedPeriod = OrderEnum ? OrderEnum.getEnum('AllocatedPeriod') : {};
    const valuesAllocatedPeriod: SelectObject[] = getValFromEnum(AllocatedPeriod);

    const OrderStatusValues = OrderEnum ? OrderEnum.getEnum('OrderStatus') : {};
    const valuesOrderStatus: SelectObject[] = getValFromEnum(OrderStatusValues);

    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderCaseType') : {};
    const orderCaseTypeValues: SelectObject[] = getValFromEnum(typeEnum);

    const referralEnum = OrderEnum ? OrderEnum.getEnum('ReferralSource') : {};
    const orderReferralSourceValues: SelectObject[] = getValFromEnum(referralEnum);

    const ServiceTypeProvidersEnum = OrderEnum ? OrderEnum.getEnum('ServiceTypeProvider') : {};
    const ServiceTypeProviders: SelectObject[] = getValFromEnum(ServiceTypeProvidersEnum);

    const serviceTypesOrderValues: SelectObject[] = [];
    props.serviceTypesOrder.list.forEach((it: IServiceType) => {
        serviceTypesOrderValues.push({ value: it.id, label: it.title ? it.title : `cpt: ${it.cpt}` });
    });

    const orderValues = toFormValues(order ? order : {}, {
        OrderSubtype: valuesOrderSubtype,
        AllocatedPeriod: valuesAllocatedPeriod,
        AuthorizationSource: valuesAuthorizationSources,
        OrderStatus: valuesOrderStatus,
        OrderTypes: props.orderTypes,
        orderCaseTypeValues: orderCaseTypeValues,
        orderReferralSourceValues: orderReferralSourceValues,
        ServiceTypeProviders: ServiceTypeProviders,
    });

    return (
        <RoleLayout>
            <Breadcrumbs
                noGenerate={true}
                items={[
                    { name: 'ORDERS', path: Router.generate(routes.ORDERS_LIST, { status: '' }) },
                    { name: `EDIT ORDER`, path: '' },
                ]}
            />
            <div className={classNames(styles.editWrap)}>
                {inProgress ? <Loader /> : !order ? <div></div> : null}
                <Form
                    orderTypeValue={props.orderTypeValue}
                    statusItemValue={props.statusItemValue}
                    status={order?.status}
                    referralSource={order?.referralSource}
                    orderDoc={order?.orderDoc}
                    setOrderDoc={(files) => handeAddOrder(files)}
                    removeOrderDoc={(id) => {
                        return false;
                    }}
                    OrderTypes={props.orderTypes}
                    valuesOrderSubtype={valuesOrderSubtype}
                    valuesOrderStatus={valuesOrderStatus}
                    orderCaseTypeValues={orderCaseTypeValues}
                    orderReferralSourceValues={orderReferralSourceValues}
                    valuesAllocatedPeriod={valuesAllocatedPeriod}
                    AuthorizationSources={valuesAuthorizationSources}
                    serviceTypesOrderValues={serviceTypesOrderValues}
                    ServiceTypeProviders={ServiceTypeProviders}
                    studentsValues={props.students}
                    files={files ? files : []}
                    setFiles={handeAdd}
                    removeFile={(id) => handeRemove(id)}
                    initialValues={{
                        orderSubtypeDropDown: valuesOrderSubtype[0],
                        orderTypeDropDown: props.orderTypes[0],
                        authorizationSourceDropDown: valuesAuthorizationSources[0],
                        ...orderValues,
                    }}
                />
            </div>
        </RoleLayout>
    );
};
export default OrderEditScreen;
